import { carsApi } from "./commerce/client";
import type { CarsLocationSuggestion } from "@/types/carsAutocomplete";

export const fetchCarsLocations = async (
  search: string,
  callback: (newOptions: CarsLocationSuggestion[]) => void
): Promise<void> => {
  try {
    const response = await carsApi.getV1CarsAutocomplete(search);

    const suggestions: CarsLocationSuggestion[] =
      response.data.suggestions?.flatMap(
        (categoryRes) =>
          categoryRes.results?.map((result) => ({
            label: result.label,
            category: categoryRes.category,
            identifier:
              result.Location === "Airport"
                ? result.iataCode
                : result.Location === "Place"
                  ? result.googlePlaceId
                  : "",
            locationType: result.Location,
          })) ?? []
      ) ?? [];

    callback(suggestions);
  } catch (error) {
    console.error("Failed to fetch car locations:", error);
    callback([]);
  }
};

export type { CarsLocationSuggestion };
